(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page_exceptions_v2_block_card1"]) return;
  try {
    
// Forcer la suppression des bordures existantes et appliquer nouveau style
document.addEventListener('DOMContentLoaded', function() {
  // Sélectionner tous les boutons dans la section
  const buttons = document.querySelectorAll('#exceptions_ul .btn, #exceptions_ul button, #exceptions_ul [class*="button"]');
  
  buttons.forEach(button => {
    // Supprimer tous les styles de bordure existants
    button.style.border = '2px solid #000 !important';
    button.style.borderRadius = '8px !important';
    button.style.padding = '12px 25px !important';
    button.style.boxShadow = 'none !important';
    button.style.outline = 'none !important';
  });
});

  } catch(e) { console.error(e); }
})();
})();
